import React from "react";
import { DialogTitleWithCloseIcon } from "../title/DialogTitleWithCloseIcon";
import { Box, Button, Dialog, DialogContent } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { StaffOverrideCamera } from "../../camera/StaffOverrideCamera";
import colors from "../../../../common/styles/colors";
import { StaffScannerProps } from "../../../qr/interfaces";
import { StaffScannerModal } from "../../../freya/scanSuccess/ScanSuccess";
import { ComponentWithChildren, IPersonBadge } from "../../../../common/types";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: colors.brownColor,
    paddingBottom: "0",
    ["@media (max-width:768px)"]: {
      fontSize: 19,
      wordBreak: "break-word",
      width: "80%",
      textAlign: "center"
    }
  },
  dialogContent: (props: { shouldUpdateStyles?: boolean }) => ({
    margin: props.shouldUpdateStyles ? "5px 0" : "0",
    padding: "0px 24px 12px 24px !important",
    backgroundColor: props.shouldUpdateStyles ? colors.lightGrey1 : "transparent"
  })
});

type Props = {
  open: boolean;
  title: string;
  subtitle?: string;
  handleClose: () => void;
  onSuccess: () => void;
  alertMessage?: string;
  options?: StaffScannerModal;
  onBackButtonClick?: () => void;
  badges: IPersonBadge[];
  reason?: string;
} & StaffScannerProps;

export const StaffOverrideCameraDialog: ComponentWithChildren<Props> = ({
  open,
  title,
  subtitle,
  handleClose,
  onSuccess,
  alertMessage,
  isFreya,
  skipUserAccessCheck,
  children,
  options,
  badges,
  onBackButtonClick,
  successOnMount,
  reason
}) => {
  const classes = useStyles({ shouldUpdateStyles: isFreya || skipUserAccessCheck });
  const className = isFreya ? classes.title : "";
  const onCloseClick = isFreya ? () => {} : handleClose;
  const { t } = useTranslation("common");

  return (
    <Dialog data-testid="camera-dialog" maxWidth="xs" fullWidth open={open} onClose={onCloseClick} sx={{ zIndex: 100000 }}>
      <DialogTitleWithCloseIcon
        title={title}
        subtitle={subtitle}
        className={className}
        handleClose={onCloseClick}
        alignCenter={isFreya}
        hideCloseIcon={isFreya}
      />
      <DialogContent className={classes.dialogContent}>
        <StaffOverrideCamera
          onSuccess={onSuccess}
          alertMessage={alertMessage}
          skipUserAccessCheck={skipUserAccessCheck}
          options={options}
          isFreya={isFreya}
          badges={badges}
          successOnMount={successOnMount}
          reason={reason}
        />
        {onBackButtonClick && (
          <Button onClick={onBackButtonClick} data-testid="scan-back-button">
            <KeyboardBackspaceIcon />
            <Box sx={{ marginLeft: "5px" }}>{t("common.buttonLabels.back")}</Box>
          </Button>
        )}
      </DialogContent>
      {children}
    </Dialog>
  );
};
